import React from "react";

const Contact = () => {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Contact Us</h1>
      <p><strong>Phone:</strong> 9676272383</p>
      <p><strong>Email:</strong> <a href="mailto:support@clearbiz.ai">support@clearbiz.ai</a></p>
    </div>
  );
}

export default Contact;
